import React from 'react';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Link } from 'react-scroll';
import gang from '../homepage.png';
import logo from '../boxrooster-white-removebg-preview.png';

const Hero = ({ showLogo = true }) => {
  const theme = useTheme();
  
  return (
    <Box
      id="hero"
      sx={{
        height: '100vh',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Background Image with Overlay */}
      <motion.div
        initial={{ scale: 1.2, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 1.5, ease: 'easeOut' }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${gang})`,
            backgroundSize: 'cover',
            backgroundPosition: { xs: 'center top', sm: 'center 30%', md: 'center' },
            filter: 'brightness(0.5)',
            mt: { xs: -8, sm: -5, md: 0 },
          }}
        />
      </motion.div>

      {/* Dark Overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1,
        }}
      />

      {/* Content */}
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
        }}
      >
        {showLogo && (
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          >
            <Box
              component="img"
              src={logo}
              alt="Boxrooster"
              sx={{
                width: { xs: '90%', sm: '75%', md: '65%', lg: '55%' },
                maxWidth: '800px',
                height: 'auto',
                margin: '0 auto',
                filter: 'brightness(0) invert(1) drop-shadow(0 0 30px rgba(255, 157, 0, 0.5))',
                mb: 0,
              }}
            />
          </motion.div>
        )}

        {showLogo && (
          <>
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 0.8, duration: 1 }}
            >
              <Typography
                variant="h5"
                sx={{
                  color: theme.palette.primary.main,
                  mb: 4,
                  mt: { xs: -6, sm: -12, md: -14, lg: -15 },
                  letterSpacing: '0.3em',
                  fontSize: { xs: '1rem', md: '1.5rem' },
                }}
              >
                THRIFT ROCK BAND FROM LONG ISLAND
              </Typography>
            </motion.div>

            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ delay: 1.1, duration: 1 }}
            >
              <Box sx={{ display: 'flex', gap: { xs: 1.5, md: 2 }, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="music" spy={true} smooth={true} offset={-70} duration={800}>
              <Button
                variant="outlined"
                size="medium"
                sx={{
                  borderColor: theme.palette.primary.main,
                  color: '#FFFFFF',
                  px: { xs: 2, md: 3 },
                  py: { xs: 0.75, md: 1 },
                  fontSize: { xs: '0.75rem', md: '0.875rem' },
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  '&:hover': {
                    borderColor: theme.palette.primary.light,
                    backgroundColor: `${theme.palette.primary.main}1A`,
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.3s',
                }}
              >
                LISTEN
              </Button>
            </Link>
            <Link to="shows" spy={true} smooth={true} offset={-70} duration={800}>
              <Button
                variant="outlined"
                size="medium"
                sx={{
                  borderColor: theme.palette.primary.main,
                  color: '#FFFFFF',
                  px: { xs: 2, md: 3 },
                  py: { xs: 0.75, md: 1 },
                  fontSize: { xs: '0.75rem', md: '0.875rem' },
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  '&:hover': {
                    borderColor: theme.palette.primary.light,
                    backgroundColor: `${theme.palette.primary.main}1A`,
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.3s',
                }}
              >
                SHOWS
              </Button>
            </Link>
            <Link to="band" spy={true} smooth={true} offset={-70} duration={800}>
              <Button
                variant="outlined"
                size="medium"
                sx={{
                  borderColor: theme.palette.primary.main,
                  color: '#FFFFFF',
                  px: { xs: 2, md: 3 },
                  py: { xs: 0.75, md: 1 },
                  fontSize: { xs: '0.75rem', md: '0.875rem' },
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  '&:hover': {
                    borderColor: theme.palette.primary.light,
                    backgroundColor: `${theme.palette.primary.main}1A`,
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.3s',
                }}
              >
                BAND
              </Button>
            </Link>
            <Link to="contact" spy={true} smooth={true} offset={-70} duration={800}>
              <Button
                variant="outlined"
                size="medium"
                sx={{
                  borderColor: theme.palette.primary.main,
                  color: '#FFFFFF',
                  px: { xs: 2, md: 3 },
                  py: { xs: 0.75, md: 1 },
                  fontSize: { xs: '0.75rem', md: '0.875rem' },
                  fontWeight: 600,
                  letterSpacing: '0.15em',
                  '&:hover': {
                    borderColor: theme.palette.primary.light,
                    backgroundColor: `${theme.palette.primary.main}1A`,
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.3s',
                }}
              >
                CONTACT
              </Button>
            </Link>
          </Box>
        </motion.div>
          </>
        )}
      </Container>

      {/* Scroll Indicator */}
      {showLogo && (
        <Box
          sx={{
            position: 'absolute',
            bottom: { xs: '140px', sm: '50px', md: '30px' },
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 2,
            display: { xs: 'none', sm: 'flex' },
            justifyContent: 'center',
          }}
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          >
            <Link to="music" spy={true} smooth={true} offset={-70} duration={800}>
              <KeyboardArrowDownIcon
                sx={{
                  fontSize: '3rem',
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                  '&:hover': { color: theme.palette.primary.light },
                }}
              />
            </Link>
          </motion.div>
        </Box>
      )}
    </Box>
  );
};

export default Hero;
